module.exports = __webpack_public_path__ + "img/type-car.0840f7cc.svg";